/**
 * Generate Study Dialog - Step 7: Review and Submit
 *
 * Migrated from: lego/page/etmf/overview/generate-study/Step7.jsx
 *
 * Final review step showing all selected options before submission
 */

import React from 'react'
import { useDialogContext } from './context/useDialogContext'
import { useServiceContext } from '../../../../root'
import type { SelectOption } from './context/DialogContext'

export function Step7() {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const dialogData = useDialogContext()
  const { selection } = dialogData

  return (
    <div className="step step7">
      <div className="form-group md-form-group">
        <div className="mcc-form-group">
          <label className="has-step-circle">
            <span className="step-circle">6</span>
            <span>{translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP7')}</span>
          </label>
        </div>
      </div>

      <p className="cparagh">{translate('ETMF_GENERATE_TRIAL_STRCT_STEP7_INFO')}</p>

      <div className="form-group md-form-group w100p">
        <label>{translate('ETMF_GENERATE_TRIAL_STRCT_SELECTED_PRODUCT')}</label>
        <div className="review-text">
          <div>{selection.product?.name || translate('NOT_AVAILABLE')}</div>
        </div>
      </div>

      <div className="form-group md-form-group w100p">
        <label>{translate('ETMF_GENERATE_TRIAL_STRCT_SELECTED_STUDY')}</label>
        <div className="review-text">
          <div>{selection.study?.name || translate('NOT_AVAILABLE')}</div>
        </div>
      </div>

      <div className="form-group md-form-group w100p">
        <label>{translate('ETMF_GENERATE_TRIAL_STRCT_SELECTED_ENVIRONMENT')}</label>
        <div className="review-text">
          <div>{selection.environment?.name || translate('NOT_AVAILABLE')}</div>
        </div>
      </div>

      <div className="form-group md-form-group w100p">
        <label>{translate('ETMF_GENERATE_TRIAL_STRCT_SELECTED_COUNTRIES')}</label>
        <div className="review-text">
          {selection.countries.length === 0
            ? translate('NOT_AVAILABLE')
            : selection.countries.map((country: SelectOption) => <div key={country.id}>{country.name}</div>)}
        </div>
      </div>

      <div className="form-group md-form-group w100p">
        <label>{translate('ETMF_GENERATE_TRIAL_STRCT_SELECTED_SITES')}</label>
        <div className="review-text">
          {selection.sites.length === 0
            ? translate('NOT_AVAILABLE')
            : selection.sites.map((site: SelectOption) => <div key={site.id}>{site.name}</div>)}
        </div>
      </div>

      <p className="cparagh strong">{translate('ETMF_GENERATE_TRIAL_STRCT_STEP7_INFO2')}</p>
    </div>
  )
}

export default Step7
